import React, { useState } from "react";
import { Form, Input, InputNumber, Button, Select, Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { SizeType } from "antd/es/config-provider/SizeContext";

const normFile = (e: any) => {
  if (Array.isArray(e)) {
    return e;
  }
  return e?.fileList;
};

const onChange = (value: string) => {
  console.log(`selected ${value}`);
};

const onSearch = (value: string) => {
  console.log("search:", value);
};

function AddCommissionSettings() {
  // form
  const [componentSize, setComponentSize] = useState<SizeType | "default">(
    "default"
  );
  const onFormLayoutChange = ({ size }: { size: SizeType }) => {
    setComponentSize(size);
  };

  return (
    <>
      {/* start data entry  */}
      <Form
        labelCol={{ span: 8 }}
        // wrapperCol={{ span: 14 }}
        layout="horizontal"
        initialValues={{ size: componentSize }}
        onValuesChange={onFormLayoutChange}
        size={componentSize as SizeType}
        // style={{ maxWidth: 600 }}
        className="grid grid-cols-1 md:grid-cols-2 lg:md:grid-cols-3 gap-5 mt-10"
      >
        <Form.Item label="اسم الخدمه">
          <Select
            showSearch
            // placeholder="نوع العميل"
            optionFilterProp="label"
            onChange={onChange}
            onSearch={onSearch}
            options={[
              {
                value: "jack",
                label: "Jack",
              },
              {
                value: "lucy",
                label: "Lucy",
              },
              {
                value: "tom",
                label: "Tom",
              },
            ]}
          />
        </Form.Item>
        <Form.Item label="عموله المنصه">
          <InputNumber className="w-full" />
        </Form.Item>
        <Form.Item label="نسبه">
          <InputNumber className="w-full" />
        </Form.Item>
        <Form.Item label="حد التسويه قيمه">
          <InputNumber className="w-full" />
        </Form.Item>
      </Form>
      {/* end */}
      <div className="mt-3">
        <div className="flex justify-end items-center mt-5 gap-10">
          <Button
            className="h-10 w-[200px] flex items-center font-bold justify-center"
            type="primary"
          >
            حفظ
          </Button>
        </div>
      </div>
    </>
  );
}

export default AddCommissionSettings;
